<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{
              this.$moment(this.startDate).format("YYYY-MM-DD")
            }}</span>
            <span v-if="$parent.endTimeShow"
              >至{{
                this.$moment(this.endDate).format("YYYY-MM-DD")
              }}</span
            >
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <div class="form-content">
          <div class="formTitle">
            <span>房号</span>
            <span>房态</span>
            <span>房号</span>
            <span>房态</span>
            <span>房号</span>
            <span>房态</span>
            <span>房号</span>
            <span>房态</span>
            <span>房号</span>
            <span>房态</span>
            <span>房号</span>
            <span>房态</span>
          </div>
        </div>
        <template v-for="item in allTableData">
          <div class="allTableTitle">
            <span>楼区 {{ item.status.split("&-+-&")[0] }}</span>
            <span>楼层 {{ item.status.split("&-+-&")[1] }}</span>
            <span>总房数：{{ item.list.length }}</span>
          </div>
          <div class="formContaniner">
            <template v-for="itemList in item.list">
              <div>{{ itemList.cNo }}</div>
              <div>
                <div v-if="itemList.checkIn == 0 && itemList.cleanStatus == 0">
                  空净房
                </div>
                <div
                  v-else-if="itemList.checkIn == 0 && itemList.cleanStatus == 1"
                >
                  空脏房
                </div>
                <div
                  v-else-if="
                    itemList.departure &&
                      itemList.checkIn == 1 &&
                      itemList.cleanStatus == 0
                  "
                >
                  住客净房(预离)
                </div>
                <div
                  v-else-if="
                    itemList.departure &&
                      itemList.checkIn == 1 &&
                      itemList.cleanStatus == 1
                  "
                >
                  住客脏房(预离)
                </div>
                <div
                  v-else-if="itemList.checkIn == 1 && itemList.cleanStatus == 0"
                >
                  住客净房
                </div>
                <div
                  v-else-if="itemList.checkIn == 1 && itemList.cleanStatus == 1"
                >
                  住客脏房
                </div>
                <div v-else-if="itemList.checkIn == 4">维修房</div>
                <div v-else-if="itemList.checkIn == 5">非卖房</div>
              </div>
            </template>
          </div>
        </template>
        <!-- <div class="total">
        <div>
          <span>合计</span>
          <span>{{ record }}条记录</span>
          <span>{{ room }}间</span>
          <span>{{ total }}</span>
        </div>
        </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      preArrivalList: [],
      // 记录
      record: 0,
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem("cname"),
      queryDate: "",
      date: "",
      statusList: [],
      allTableData: [],
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "H08.当前客房状态表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    //把所有搜索都隐藏
    this.$parent.closeshow();
    this.$parent.showLq = true;
    this.$parent.showLc = true;
    this.$parent.showFt = true;
    this.$parent.chaxunvib = true;
    this.getPreArrivalList();
    this.queryDate = new Date();
    this.date = this.$moment(this.queryDate).format("YYYY-MM-DD HH:mm:ss");
    //
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      this.getPreArrivalList();
    },
    dateChange(data) {
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getPreArrivalList() {
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/reportForMembers/selectNowRoomSatus").then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status != 200)
          return vm.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        this.$parent.datacount = res.data.length;
        let list = res.data;
        if (this.$parent.louqu) {
          list = list.filter((item) => {
            return item.cArea == this.$parent.louqu;
          });
        }
        if (this.$parent.louceng) {
          list = list.filter((item) => {
            return item.cFloor == this.$parent.louceng;
          });
        }
        if (this.$parent.fantai) {
          if (this.$parent.fantai == "kjf") {
            list = list.filter((item) => {
              return item.checkIn == 0 && item.cleanStatus == 0;
            });
          } else if (this.$parent.fantai == "kzf") {
            list = list.filter((item) => {
              return item.checkIn == 0 && item.cleanStatus == 1;
            });
          } else if (this.$parent.fantai == "zkjf") {
            list = list.filter((item) => {
              return item.checkIn == 1 && item.cleanStatus == 0;
            });
          } else if (this.$parent.fantai == "zkzf") {
            list = list.filter((item) => {
              return item.checkIn == 1 && item.cleanStatus == 1;
            });
          } else if (this.$parent.fantai == "wxf") {
            list = list.filter((item) => {
              return item.checkIn == 4;
            });
          } else if (this.$parent.fantai == "fmf") {
            list = list.filter((item) => {
              return item.checkIn == 5;
            });
          } else if (this.$parent.fantai == "ylf") {
            list = list.filter((item) => {
              return (
                item.departureDate ==
                  this.$moment(new Date()).format("YYYY-MM-DD") &&
                item.checkIn == 1
              );
            });
          }

          list.forEach((item) => {
            if (
              item.departureDate ==
              this.$moment(new Date()).format("YYYY-MM-DD")
            ) {
              item.departure = true;
            }
          });
        }
        // console.log(222, list);
        let allList = list;
        this.record = res.data.length;

        this.$store.state.preArrivalList = res.data;
        this.$store.state.preArrivalName = "H08.当前客房状态表";
        this.allTableData = [];
        this.statusList = Array.from(
          new Set(
            allList.map((item) => `${item.areaname}&-+-&${item.floorname}`)
          )
        );

        this.statusList.filter((item) => {
          this.allTableData.push({
            status: item,
            list: [],
          });
        });
        this.allTableData.filter((item) => {
          item.list = allList.filter((itemList) => {
            return (
              itemList.areaname == item.status.split("&-+-&")[0] &&
              itemList.floorname == item.status.split("&-+-&")[1]
            );
          });
        });
        this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
      });
    },
  },
};
</script>

<style scoped>
.reportTable {
  /* padding: 1em; */
  height: 100%;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1em;
  height: 92px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 1em;
}
.formTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  line-height: 25px;
  margin-bottom: 1em;
  font-size: 14px;
}
.formTitle > span {
  display: inline-block;
  width: 8.33%;
  text-align: center;
}
.PreArrivalItem {
  /* width: 8%; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1em;
}
.PreArrivalItem > div {
  width: 8em;
  text-align: center;
}
.formContaniner {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  border-bottom: 1px dashed #000;
}
.formContaniner > div {
  width: 8.33%;
  font-size: 14px;
}
.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 8%;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 8%;
  text-align: center;
  border: 1px solid #000;
}
.report {
  padding: 1em;
  overflow: scroll;
}
.queryDate {
  position: relative;
  top: 0px;
  width: 100%;
  height: 3em;
  line-height: 3em;
  background-color: #e7f0ff;
}
.queryDate > span {
  margin: 15px;
}
.el-input {
  background-color: transparent;
}
.allTableTitle > span {
  display: inline-block;
  margin-right: 2em;
  font-size: 14px;
}
</style>
